import React, { FC } from 'react';
import { useVaultsByPool } from '@app/hooks/ichi/useVaultsByPool';
import { VaultInfo } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/VaultInfo';
import { useDerivedLiquidityByIchiInfo } from '@app/state/liquidityByIchiStore';
import { AmountsInput } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/AmountsInput';
import { CreateIchiPositionWithKpNft } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/CreateIchiPositionWithKpNft';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { VaultSelector } from '@app/screens/liquidity/AddLiquidityV3/components/ichi/VaultSelector';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const AddLiquidityByIchi: FC<Props> = ({ mintInfo: commonMintInfo }) => {
  const { currencyA, currencyB } = useLiquidityWizardState();
  const { poolAddress } = commonMintInfo;
  const { data: vaultsAddresses } = useVaultsByPool(poolAddress);

  const mintInfo = useDerivedLiquidityByIchiInfo(poolAddress);
  const { vaultDetails } = mintInfo;

  return (
    <>
      <VaultSelector vaultsAddresses={vaultsAddresses} />
      <VaultInfo vaultDetails={mintInfo.vault} />
      <AmountsInput vaultDetails={vaultDetails} />
      <CreateIchiPositionWithKpNft
        currencyA={currencyA}
        currencyB={currencyB}
        mintInfo={mintInfo}
      />
    </>
  );
};
